class FreeShipping extends SearchForm {
  constructor() {
    super();

    this.conversionRate = parseFloat(Shopify.currency.rate) || 1;

    // 当前金额（分）
    this.amount = parseInt(this.dataset.amount) || 0;

    // 包邮阈值
    this.baseThreshold = parseInt(this.dataset.threshold) || 0;
    this.threshold = this.baseThreshold * this.conversionRate;

    // 满赠阈值
    this.baseGiftThreshold = parseInt(this.dataset.giftThreshold) || 0;
    this.giftThreshold = this.baseGiftThreshold * this.conversionRate;

    // 是否启用满赠
    this.hasGift = this.baseGiftThreshold > 0;

    // DOM
    this.progressBar = this.querySelector('[data-progress-bar]');
    this.freePoint = this.querySelector('[data-free-point]');
    this.giftPoint = this.querySelector('[data-gift-point]');

    this.met = this.querySelector('[data-free-shipping="true"]');
    this.unmet = this.querySelector('[data-free-shipping="false"]');

    this.amountText = this.querySelector('[data-amount]');
    this.amountText2 = this.querySelector('[data-amount2]');

    this.update();
    this.classList.add('free-shipping--active');
  }

  update() {
    this.updateProgress();
    this.updateShippingState();
  }

  // ===== 进度条 =====
  updateProgress() {
    if (!this.progressBar) return;

    // 满赠关闭时，只按包邮算
    const max = this.hasGift
      ? Math.max(this.giftThreshold, this.threshold)
      : this.threshold;

    const percent = Math.min(this.amount / max, 1) * 100;

    const bar = this.progressBar.querySelector('.progress-bar');
    if (bar) {
      bar.style.width = `${percent}%`;
    }

    this.updatePoints(max);
  }

  updatePoints(max) {
    if (!this.freePoint) return;

    // ===== 包邮节点 =====
    const freePercent = (this.threshold / max) * 100;
    this.freePoint.style.left = `${freePercent}%`;

    this.freePoint.classList.toggle(
      'active',
      this.amount >= this.threshold
    );

    // ===== 满赠节点 =====
    if (this.hasGift && this.giftPoint) {
      this.giftPoint.style.left = `100%`;

      this.giftPoint.classList.toggle(
        'active',
        this.amount >= this.giftThreshold
      );

      this.giftPoint.style.display = '';
    } else if (this.giftPoint) {
      // 满赠关闭 → 隐藏
      this.giftPoint.style.display = 'none';
      this.giftPoint.classList.remove('active');
    }
  }

  // ===== 文案状态 =====
  updateShippingState() {
    if (!this.met || !this.unmet) return;

    const locale = document.documentElement.getAttribute('lang');

    // ===== 包邮 =====
    if (this.amount >= this.threshold) {
      this.met.removeAttribute('aria-hidden');
      this.unmet.setAttribute('aria-hidden', 'true');
    } else {
      this.met.setAttribute('aria-hidden', 'true');
      this.unmet.removeAttribute('aria-hidden');

      if (Shopify.currency.active && this.amountText) {
        const remaining = (this.threshold - this.amount) / 100;

        this.amountText.textContent = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: Shopify.currency.active,
        }).format(remaining);
      }
    }

    // ===== 满赠（仅在开启时执行）=====
    if (this.hasGift && this.amountText2) {
      if (this.amount >= this.giftThreshold) {
        this.amountText2.textContent = '🎁 Gift unlocked';
      } else {
        const remainingGift = (this.giftThreshold - this.amount) / 100;

        this.amountText2.textContent = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: Shopify.currency.active,
        }).format(remainingGift);
      }
    }
  }
}

customElements.define('free-shipping', FreeShipping);